import { render, staticRenderFns } from "./PatientSupportTools.vue?vue&type=template&id=5a479d68&scoped=true&"
import script from "./PatientSupportTools.vue?vue&type=script&lang=js&"
export * from "./PatientSupportTools.vue?vue&type=script&lang=js&"
import style0 from "./PatientSupportTools.vue?vue&type=style&index=0&id=5a479d68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a479d68",
  null
  
)

export default component.exports